<template>
<div>
 <el-card>
            <el-row>
                <el-col :span="24">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/Api/Index' }">接口列表</el-breadcrumb-item>
                        <el-breadcrumb-item>新增接口</el-breadcrumb-item>
                    </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            
            <el-col :span="20">
                <el-form :model="ApiModel" :rules="rules" ref="ApiModel" label-width="100px" class="demo-ruleForm">
                    <el-row class="font_left">
                        <el-col :span="24">
                            <el-row class="font_left">
                                <el-col :span="18">
                                    <el-form-item size="small" label="名称" label-width="150px" prop="Name">
                                        <el-input v-model="ApiModel.Name" placeholder="请填写名称" ></el-input>
                                    </el-form-item>
                                   <el-form-item size="small" label="请求链接" label-width="150px" prop="RequestUrl">
                                        <el-input v-model="ApiModel.RequestUrl" placeholder="请填写请求链接" ></el-input>
                                    </el-form-item>
                                      <el-form-item size="small" label="请求类型"  label-width="150px" prop="Type">
                                        <el-select style="width:100%" v-model="ApiModel.Type" placeholder="请求类型">
                                            <el-option label="" value="--请选择--"></el-option>
                                            <el-option label="POST" value="POST"></el-option>
                                            <el-option label="GET" value="GET"></el-option>
                                        </el-select>
                                    </el-form-item>
                                   
                                </el-col>
                               
                                
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row class="mar_top_20">
                        <el-button type="primary" @click="submitForm(ApiModel)">保存</el-button>
                        <el-button @click="cancle">取消</el-button>
                    </el-row>
                </el-form>
            </el-col>
        </el-card>
    
</div>
</template>
<script>
import { GetApiPageList,AddApi } from "../../until/ZeusApiSDK/Logic/ApiDataLogic";
import { Predicate } from "../../until/ZeusApiSDK/Model/Predicate";
export default {
  data() {
    return {
     //currentUser:{},//当前登录用户信息
     ApiModel:{
        ID:'',
        RequestURL:'',
        Name:'',
        Type:'',
        RegisterTime:'',//注册时间
        IsOpen:'',//是否启用
        DeleteTime:'',
        IsDelete:'',
         },
        rules:{
                  Name: [
                       {required: true, message: '请填写名称',trigger: 'blur'}
                   ],
                   RequestUrl: [
                        { required: true, message: '请求链接', trigger: 'blur' }
                   ],
                  Type: [
                        { required: true, message: '请求类型', trigger: 'change' }
                   ],
              }
    

    };
  },
  created() {
             //获取当前用户
            // this.getCurrentUser();
  },
  methods: {

       //时间转换 不够10 添加0
            p(s) {
                return s < 10 ? '0' + s : s
            },
              NewGuid: function guid() {
               return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
                     c
                    ) {
                        var r = (Math.random() * 16) | 0,
                        v = c == "x" ? r : (r & 0x3) | 0x8;
                        return v.toString(16);
                    });
              },
             //获取当前用户
            // getCurrentUser:function(){
            //     var userinfo = window.sessionStorage.getItem("userinfo");
            //     userinfo = JSON.parse(Decrypt(userinfo));
            //     this.currentUser = userinfo;
            // },
             //提交信息
            submitForm:async function(formInfo){
                this.$refs['ApiModel'].validate((valid) => {
                    if (valid) {
                         var datetime1 = new Date();
                         datetime1=  datetime1.getFullYear() + '-' + this.p((datetime1.getMonth() + 1)) + '-' + this.p(datetime1.getDate())+ ' ' + this.p(datetime1.getHours())+ ':' + this.p(datetime1.getMinutes())+ ':' + this.p(datetime1.getSeconds());                          
                        formInfo.ID = this.NewGuid();
                        formInfo.IsDelete = 0;
                        formInfo.IsOpen = 1;
                        formInfo.RegisterTime =datetime1;
                        console.log(formInfo);
                        AddApi(formInfo).then(res=>{
                         console.log(res);
                            if(res='success'){

                                 this.$message({
                                    message: '添加成功 ',
                                    type: 'success'
                                    });
                                //添加成功 添加日志 并跳转到入职管理页
                                //this.addLog(formInfo);
                                this.$router.push('/Api/Index');
                            }else{
                                alert('添加失败！！');
                            }
                        });
                    } else {
                        alert('请补全信息！！');
                        return false;
                    }
                });
            },
            //取消 跳转到详情页
            cancle:function(){
                this.$router.go(-1);
            },
             //添加日志
            // addLog:function(formInfo){
            //     //添加接口成功，添加日志
            //     AddApi("添加Api接口",
            //         this.currentUser.UserId,
            //         this.currentUser.TrueName,
            //         "添加接口",
            //         '添加接口成功',
            //         formInfo.UserCode,
            //         formInfo,
            //         {},
            //         "userInfoModel");

            // },

  }
};
</script>